import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=1bc5ea12&scoped=true&"
import script from "./banner.vue?vue&type=script&lang=js&"
export * from "./banner.vue?vue&type=script&lang=js&"
import style1 from "./banner.vue?vue&type=style&index=1&id=1bc5ea12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc5ea12",
  null
  
)

export default component.exports